import { render, staticRenderFns } from "./ListaPrefeituras.vue?vue&type=template&id=8597d302&"
import script from "./ListaPrefeituras.vue?vue&type=script&lang=js&"
export * from "./ListaPrefeituras.vue?vue&type=script&lang=js&"
import style0 from "./ListaPrefeituras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports